import { CallDto } from '../../data-transfer-objects';

export enum CallSocketEventTypes {
  INCOMING_CALL_CREATED = '[Call] Incoming Call Created',
  OUTGOING_CALL_CREATED = '[Call] Outgoing Call Created',
  CALL_UPDATED = '[Call] Call Updated',
}

export interface CallWSPayload {
  call: CallDto;
  memberId: string;
}

/**
 * Events
 */
export class CallCreatedWSMessage {
  constructor(
    public type: CallSocketEventTypes.INCOMING_CALL_CREATED,
    public payload: CallWSPayload
  ) {}
}

export class OutgoingCallCreatedWSMessage {
  constructor(
    public type: CallSocketEventTypes.OUTGOING_CALL_CREATED,
    public payload: CallWSPayload
  ) {}
}

export class CallUpdatedWSMessage {
  constructor(
    public type: CallSocketEventTypes.CALL_UPDATED,
    public payload: CallWSPayload
  ) {}
}
